// app/dashboard/dashboard_Super.js

(function () {
    'use strict';
    var controllerId = 'dashboard_Super';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', 'common', 'datacontext', 'sectionMenu', dashboard_SuperFn]);

    function dashboard_SuperFn($rootScope, $scope, common, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = " dashview";
        var vm = this;
        vm.title = 'Superuser';
        vm.sectionMenu = sectionMenu.setSection('');        
        vm.getAll = getDashboard();
        vm.dashboard = {};

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getDashboard()];
            common.activateController(promises, controllerId)
                    .then(function () { });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function getDashboard() {
            /*datacontext.dashboard_get().then(function (data) {
                vm.dashboard = data;
            });*/
        }
    }
})();